export enum NetworkResourceType {
  COSTS = 'costs',
  TRAFFIC = 'traffic',
}
